<template>
    <div class="border-t w-full">
        <h1 class="text-xl font-semibold text-gray-900">Kundenmeinungen</h1>
        <div v-for="rating in ratings" :key="rating.id" class="py-2">
            <div>
              <StarRating
                class=""
                :show-rating="false"
                :star-size="25"
                :read-only="true"
                v-model="rating.rating"
              ></StarRating>
            </div>
            <div>
              <p class="inline pr-2 text-gray-900 text-xl font-semibold">{{ rating.user }}</p>
              <p class="inline text-gray-900 text-xs">{{ rating.date }}</p>
            </div>
            <div class="py-2">
                <p class="text-gray-900 text-md inline-block">{{ rating.description }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
    props: {
        ratings: Array
    },
    components: {
        StarRating
    },
    data() {
        return {

        }
    },
    computed: {
        getRatings() {
            return this.ratings
        },
    }
}
</script>

<style>

</style>